import { useRef, useState, type MouseEvent } from 'react';

type Position = {
  x: number;
  y: number;
};

type VirtualAnchor = {
  getBoundingClientRect: () => DOMRect;
};

export const useCursorHoverState = (disabled?: boolean) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState<Position | null>(null);

  const virtualRef = useRef<VirtualAnchor>({ getBoundingClientRect: () => new DOMRect() });

  if (position) {
    virtualRef.current = { getBoundingClientRect: () => new DOMRect(position.x, position.y, 0, 0) };
  }

  const trackPosition = (event: MouseEvent) => setPosition({ x: event.clientX, y: event.clientY });

  return {
    open: !disabled && isOpen,
    onOpenChange: setIsOpen,
    virtualRef,
    onMouseEnter: (event: MouseEvent) => {
      trackPosition(event);
      setIsOpen(true);
    },
    onMouseMove: trackPosition,
    onMouseLeave: () => setIsOpen(false),
  };
};
